import { render, staticRenderFns } from "./add_fagao.vue?vue&type=template&id=cf683010&scoped=true&"
import script from "./add_fagao.vue?vue&type=script&lang=js&"
export * from "./add_fagao.vue?vue&type=script&lang=js&"
import style0 from "./add_fagao.vue?vue&type=style&index=0&id=cf683010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf683010",
  null
  
)

export default component.exports